/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates an product card base price instance
 *
 * @module enervee_utils.product_card
 */
function productCardBasePriceDirective() {
    return {
        restrict: 'E',
        // this is needed to fix spacing issues
        replace: true,
        scope: {
            product: '='
        },
        controller: productCardBasePriceController,
        template: require('./basePriceView.html')
    };
}

productCardBasePriceController.$inject = ['$scope'];
function productCardBasePriceController($scope) {
    $scope.showParentPriceText = false;

    var isSiblingProductsEnabled = $scope.product.category.sibling_products_toggle;

    if (isSiblingProductsEnabled && $scope.product.varying_features_json && $scope.product.varying_features_json.length > 0) {
        $scope.showParentPriceText = true;
    }
}

module.exports = productCardBasePriceDirective;
